import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import DeleteQueryBlueprintForm from './form'

const DeleteQueryBlueprintDialog = React.forwardRef(function DeleteQueryBlueprintDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false, blueprint: null })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false, blueprint: null })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (blueprint) => {
      setDialogState({ open: true, processing: false, blueprint: structuredClone(blueprint) })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Delete Query Blueprint'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DeleteQueryBlueprintForm
            blueprint={dialogState.blueprint}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

DeleteQueryBlueprintDialog.propTypes = {
  onComplete: PropTypes.func
}

DeleteQueryBlueprintDialog.defaultProps = {
  onComplete: () => {}
}

export default DeleteQueryBlueprintDialog
